import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import '../button';
import './item';
import { menuStyles } from './styles';
import { mobileAndTabletCheck } from 'kailib';
let LitMenu = class LitMenu extends LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.mobile = mobileAndTabletCheck();
    }
    render() {
        return html `
        <lit-select 
            @menuSelect = "${this.onMenuSelect}" 
            .isMenu = "${true}">
            <div slot = "selected"><slot name = "label">${this.label}</slot></div>
            <slot></slot>
        </lit-select>`;
    }
    onMenuSelect() {
        var _a;
        const el = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`lit-select`);
        el.hide();
        el.focus();
    }
};
LitMenu.styles = menuStyles;
__decorate([
    property({ type: String })
], LitMenu.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], LitMenu.prototype, "mobile", void 0);
LitMenu = __decorate([
    customElement('lit-menu')
], LitMenu);
export { LitMenu };
